import agentServicesIcon from '@assets/service_provider_categories/agent_services.svg';
import crewServicesIcon from '@assets/service_provider_categories/crew_services.svg';
import electronicsNavigationCommunicationIcon from '@assets/service_provider_categories/electronics_navigation_communication.svg';
import emergencyServicesIcon from '@assets/service_provider_categories/emergency_services.svg';
import exteriorWashDetailIcon from '@assets/service_provider_categories/exterior_wash_detail.svg';
import hullExteriorIcon from '@assets/service_provider_categories/hull_exterior.svg';
import interiorCleaningIcon from '@assets/service_provider_categories/interior_cleaning.svg';
// import marinaAndFuelIcon from '@assets/service_provider_categories/marina_and_fuel.svg';
import mechanicalElectricalIcon from '@assets/service_provider_categories/mechanical_electrical.svg';
import operationalConciergeIcon from '@assets/service_provider_categories/operational_concierge.svg';
import safetyInspectionIcon from '@assets/service_provider_categories/safety_inspection.svg';
import upholsteryCanvasIcon from '@assets/service_provider_categories/upholstery_canvas.svg';
import yachtManagementIcon from '@assets/service_provider_categories/yacht_management.svg';

export const SERVICE_CATEGORIES = [
  { id: 'hull_exterior', title: 'Hull & Exterior', icon: <img src={hullExteriorIcon} alt="" /> },
  {
    id: 'exterior_wash_detail',
    title: 'Exterior Wash & Detail',
    icon: <img src={exteriorWashDetailIcon} alt="" />,
  },
  {
    id: 'interior_cleaning',
    title: 'Interior & Cleaning',
    icon: <img src={interiorCleaningIcon} alt="" />,
  },
  {
    id: 'mechanical_electrical',
    title: 'Mechanical & Electrical',
    icon: <img src={mechanicalElectricalIcon} alt="" />,
  },
  {
    id: 'electronics_navigation_communication',
    title: 'Electronics, Navigation & Communication',
    icon: <img src={electronicsNavigationCommunicationIcon} alt="" />,
  },
  {
    id: 'safety_inspection',
    title: 'Safety, Inspection & Compliance',
    icon: <img src={safetyInspectionIcon} alt="" />,
  },
  {
    id: 'operational_concierge',
    title: 'Operational & Concierge',
    icon: <img src={operationalConciergeIcon} alt="" />,
  },
  {
    id: 'yacht_management',
    title: 'Yacht Management',
    icon: <img src={yachtManagementIcon} alt="" />,
  },
  {
    id: 'upholstery_canvas',
    title: 'Upholstery & Canvas',
    icon: <img src={upholsteryCanvasIcon} alt="" />,
  },
  // { id: 'marina_and_fuel', title: 'Marina and Fuel', icon: <img src={marinaAndFuelIcon} alt="" /> },
  { id: 'crew_services', title: 'Crew Services', icon: <img src={crewServicesIcon} alt="" /> },
  { id: 'agent_services', title: 'Agent Services', icon: <img src={agentServicesIcon} alt="" /> },
  {
    id: 'emergency_services',
    title: 'Emergency Services',
    icon: <img src={emergencyServicesIcon} alt="" />,
  },
];

export const categoryHandler = (service: any) => {
  const rawCategoryId = service?.trim() || 'other';
  return SERVICE_CATEGORIES.find((option) => option.id === rawCategoryId)?.title;
};
